import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import apiService from '../services/api';
import PageBackground from '../components/PageBackground';
import VastuSubHeader from '../components/VastuSubHeader';
import './VastuStyles.css'; // Relies on our scoped styles

const ConsultantDirectoryPage = () => {
  const [consultants, setConsultants] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    apiService.getVastuConsultants()
      .then(res => setConsultants(res.data || []))
      .catch(err => console.error(err))
      .finally(() => setIsLoading(false));
  }, []);

  const bgUrl = 'https://images.unsplash.com/photo-1558535235-943a5c518b2b?auto=format&fit=crop&w=1920&q=80';

  // Helper for initials
  const getInitials = (name = '') => name.split(' ').map(p => p[0]).join('').slice(0, 2).toUpperCase() || 'VA';

  return (
    <div className="vastu-page">
      <PageBackground imageUrl={bgUrl} />
      <VastuSubHeader />

      <div className="vastu-main-content-wrapper" style={{ marginTop: '2rem' }}>
        <div className="section-heading" style={{ textAlign: 'center', marginBottom: '4rem' }}>
          <h1>Meet Our Vastu Experts</h1>
          <p>Browse our directory of verified professionals to find the right guide for your space.</p>
        </div>

        {isLoading ? (
          <div className="loading-spinner">Loading consultants...</div>
        ) : consultants.length === 0 ? (
          <div className="empty-state">No consultants are currently available. Please check back later.</div>
        ) : (
          /* --- THIS IS THE NEW 3-COLUMN GRID --- */
          <div className="consultant-directory-grid">
            {consultants.map((c, index) => (
              <motion.article 
                key={c._id} 
                className="directory-card"
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                whileHover={{ y: -8, boxShadow: '0 15px 35px rgba(0,0,0,0.1)' }}
              >
                {/* Top Half: Photo & Primary Info */}
                <div className="directory-card-top">
                  <div className="directory-avatar">
                    {c.profilePhoto?.url ? <img src={c.profilePhoto.url} alt={c.displayName} /> : <span>{getInitials(c.displayName)}</span>}
                  </div>
                  <h3 className="directory-name">{c.displayName}</h3>
                  <p className="directory-headline">{c.profileHeadline || 'Vastu Consultant'}</p>
                  
                  <div className="directory-stats">
                    <span className="stat-item"><i className="fas fa-star" style={{ color: '#f59e0b' }}></i> {c.ratingAverage || 5.0}</span>
                    <span className="stat-separator">•</span>
                    <span className="stat-item"><i className="fas fa-briefcase" style={{ color: 'var(--vastu-green)' }}></i> {c.experienceYears || 0}+ Yrs</span>
                  </div>
                </div>
                
                {/* Bottom Half: Bio & Action */}
                <div className="directory-card-bottom">
                  <div className="directory-tags">
                    {(c.specializations || []).slice(0, 3).map((spec) => (
                      <span key={spec}>{spec}</span>
                    ))}
                  </div>
                  
                  <Link to={`/vastu/consultants/${c._id}`} className="primary-btn btn-full-width">
                    View Full Profile
                  </Link>
                </div>
              </motion.article>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default ConsultantDirectoryPage;